import {
    MAJ_SEARCH_REQUEST,
    MAJ_SEARCH_RESULTS,
    MAJ_OPERATION_IN_SEARCH_RESULTS,
    MAJ_SUBMIT_TO_PROCESS,
    MAJ_OPERATION_SELECTED,
    ADD_VENTILATION_FROM_OPERATION_SELECTED,
    REMOVE_VENTILATION_FROM_OPERATION_SELECTED,
    ADD_IN_ALL_OPERATIONS_SELECTED,
    REMOVE_FROM_ALL_OPERATIONS_SELECTED
} from '../mutations-type'
var _ = require('underscore');

// initial state
const state = {
    searchRequest: {},
    searchResults: [],
    operationSelected: null,
    submitToProcess: false,
    operationsSelected:[]
}

// mutations
const mutations = {
    calculResteVentilation: function () {
        //CALCUL DU RESTE VENTILATION
        var montant = 0;
        state.operationSelected.facture_operation.forEach(function (item, index, array) {
            montant += parseFloat(item.montant);
        })
        state.operationSelected.reste_ventilation.ResteVentilation = Math.abs(Math.abs(parseFloat(state.operationSelected.montant)) - montant).toFixed(2);
        state.operationSelected.reste_ventilation.SommeVentilation=montant;
    },
    [ADD_IN_ALL_OPERATIONS_SELECTED](state,operation) {
        if (!_.contains(state.operationsSelected, operation))
            state.operationsSelected.push(operation)
    },
    [REMOVE_FROM_ALL_OPERATIONS_SELECTED] (state,operation) {
        state.operationsSelected.forEach(function (item, index, array) {
            if (item.id == operation.id) {
                state.operationsSelected.splice(index, 1)
                return true
            }
        })
    },
    [MAJ_SEARCH_REQUEST] (state, data) {
        state.searchRequest = data;
    },
    [MAJ_SEARCH_RESULTS] (state, data) {
        state.searchResults = data;
    },
    [MAJ_SUBMIT_TO_PROCESS] (state, submitToProcess) {
        state.submitToProcess = submitToProcess;
    },
    [MAJ_OPERATION_SELECTED] (state, operation) {
        state.operationSelected = operation;
        mutations.calculResteVentilation()
    },
    [MAJ_OPERATION_IN_SEARCH_RESULTS] (state, operation) {
        if (state.searchResults.length > 0)
            if (_.contains(state.searchResults, operation))
                state.searchResults[_.indexOf(state.searchResults, operation)] = operation
    },
    [ADD_VENTILATION_FROM_OPERATION_SELECTED] (state, ventilation) {
        if (!_.contains(state.operationSelected.facture_operation, ventilation))
            state.operationSelected.facture_operation.push(ventilation)
        mutations.calculResteVentilation()
    },
    [REMOVE_VENTILATION_FROM_OPERATION_SELECTED] (state, ventilation) {
        // console.log(_.isMatch(state.operationSelected.facture_operation[2], ventilation));
        state.operationSelected.facture_operation.forEach(function (item, index, array) {
            if (item.id == ventilation.id) {
                state.operationSelected.facture_operation.splice(index, 1)
                return true
            }
        })
        mutations.calculResteVentilation()
    }
}

const actions = {

    majSearchResults({commit}, results) {
        commit(MAJ_SEARCH_RESULTS, results)
    },
    majSearchRequest({commit}, results) {
        commit(MAJ_SEARCH_REQUEST, results)
    },
    submitToProcess({commit}, submitToProcess) {
        commit(MAJ_SUBMIT_TO_PROCESS, submitToProcess)
    },
    majOperationInSearchResults({commit}, operation) {
        commit(MAJ_OPERATION_IN_SEARCH_RESULTS, operation)
    },
    removeVentilationFromOperationSelected({commit},ventilation) {
        commit(REMOVE_VENTILATION_FROM_OPERATION_SELECTED,ventilation)
    },
    addVentilationFromOperationSelected({commit},ventilation) {
        commit(ADD_VENTILATION_FROM_OPERATION_SELECTED,ventilation)
    },
    majOperationSelected({commit}, operation) {
        commit(MAJ_OPERATION_SELECTED, operation)
    },
    removeOperationFromAllSelected({commit}, operation) {
        commit(REMOVE_FROM_ALL_OPERATIONS_SELECTED, operation)
    },
    addOperationinAllSelected({commit}, operation) {
        commit(ADD_IN_ALL_OPERATIONS_SELECTED, operation)
    },
}

const getters = {
    getOperationSelected : state => {
        return state.operationSelected
    },
    getSearchResults : state => {
        return state.searchResults
    },
    getSearchRequest:state => {
        return state.searchRequest
    },
    getSubmitToProcess:state => {
        return state.submitToProcess
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/vuex/modules/searchOperations.js